module.exports = __webpack_public_path__ + "static/img/product-top-3.e2a51b20.png";